import { render, staticRenderFns } from "./EMailChange.vue?vue&type=template&id=0f8b2d3f&"
import script from "./EMailChange.vue?vue&type=script&lang=js&"
export * from "./EMailChange.vue?vue&type=script&lang=js&"
import style0 from "./EMailChange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports